import whatsapp from "../../assets/whatsapplogo.svg";
import { WHATSAPP_LINK } from "../../lib/constants";

export const HOME_WRAP = "mx-auto w-full max-w-[1920px] px-5 lg:px-10 xl:px-[130px]";

export function WhatsAppButton({ className = "", iconClassName = "h-6 w-6", children = "Book on WhatsApp" }) {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center justify-center gap-2 rounded-[10px] bg-[#079b65] px-6 py-3 font-bold text-white transition hover:bg-[#087e54] ${className}`}
    >
      <img src={whatsapp} alt="" className={iconClassName} />
      {children}
    </a>
  );
}

export function SectionEyebrow({ children, className = "" }) {
  return (
    <div className={`mb-2 flex items-center gap-3 text-[14px] font-medium text-[#0052ff] md:text-[16px] ${className}`}>
      <span className="h-[2px] w-11 bg-[#0052ff]" />
      <span>{children}</span>
    </div>
  );
}

export function ArrowControls({ onPrev, onNext, label }) {
  return (
    <div className="hidden gap-3 md:flex">
      <button
        type="button"
        onClick={onPrev}
        data-testid={`${label}-prev`}
        className="grid h-10 w-10 place-items-center rounded-full bg-white text-[#06386f] shadow-[0_10px_28px_rgba(10,31,102,0.08)]"
        aria-label={`Previous ${label}`}
      >
        <span aria-hidden="true">&lt;</span>
      </button>
      <button
        type="button"
        onClick={onNext}
        data-testid={`${label}-next`}
        className="grid h-10 w-10 place-items-center rounded-full bg-[#064d7c] text-white shadow-[0_18px_36px_rgba(6,77,124,0.24)]"
        aria-label={`Next ${label}`}
      >
        <span aria-hidden="true">&gt;</span>
      </button>
    </div>
  );
}
